module.exports = __webpack_public_path__ + "img/googlePlay.69e1db02.png";